import { BoardAuthorHOC } from '../../../Author/hocs/BoardAuthorHOC/BoardAuthorHOC';
import { BoardStarredButtonHOC } from '../../../StarredButton/hocs/BoardStarredButtonHOC/BoardStarredButtonHOC';
import { ArchiveHOC } from '../../../Archive/hocs/ArchiveHOC/ArchiveHOC';
import { BoardNameHOC } from '../../../BoardName/hocs/BoardNameHOC/BoardNameHOC';
import { BoardDescriptionHOC } from '../../../BoardDescription/hocs/BoardDescriptionHOC/BoardDescriptionHOC';
import * as React from 'react';
import { CLASS_BOARD_DETAILS } from '../../../../constants';
import { IInfoProps } from './types';
import './_Info.scss';
import { BOARD_EMPTY_DUMMY_TEXT, BOARD_EMPTY_DUMMY_TITLE } from './constants';

export const Info = ({
    boardId,
    isDescription,
    isReadonly,
}: IInfoProps) => {
    const className = CLASS_BOARD_DETAILS + '-info';
    const classTitle = className + '__title';
    const classEmptyDummy = className + '__empty-dummy';

    const [isDescriptionEditing, setDescriptionEditing] = React.useState(null);
    const [nameHeight, setNameHeight] = React.useState(0);

    const Icon = require(`!!@svgr/webpack!./rocket.svg`).default;

    return <div className={className}>
        <div className={className + '__author-and-starred'}>
            <BoardAuthorHOC boardId={boardId} />
            <BoardStarredButtonHOC boardId={boardId} />
            <ArchiveHOC boardId={boardId} />
        </div>
        <div
            className={`
                ${classTitle}
                ${!isDescription && !isDescriptionEditing ? classTitle + '--empty' : ''}
            `}
        >
            <BoardNameHOC boardId={boardId} isReadonly={isReadonly} setNameHeight={setNameHeight} />
            <BoardDescriptionHOC boardId={boardId} setDescriptionEditing={setDescriptionEditing} nameHeight={nameHeight} />
        </div>
        {!isDescription && !isDescriptionEditing &&
            <div className={classEmptyDummy}>
                <Icon />
                <div className={classEmptyDummy + '-title'}>
                    {BOARD_EMPTY_DUMMY_TITLE}
                </div>
                <div className={classEmptyDummy + '-text'}>
                    {BOARD_EMPTY_DUMMY_TEXT}
                </div>
            </div>
        }
    </div>;
}
